module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="header-container">\n	<a href="javascript:void(0)" class="ion-android-menu main-menu-button hidden-desktop js-open-main-menu"></a>\n	<h1>\n		<a href="/" target="_blank">\n			<picture>\n				<img src="/assets/images/nrl-fantasy-logo-header.svg" border="0" alt="Advertisement" />\n			</picture>\n		</a>\n	</h1>\n	<div class="info-section">\n		';
 if(id) { 
__p+='\n			<div class="user-info">\n				<p class="sponsor-text">Presented By</p>\n				<a href="https://hisense.com.au/" target="_blank" rel="noopener noreferrer">\n					<picture class="img-wrapper">\n						<img class="sponsor" src="/assets/images/sponsor_desktop.svg" alt="Advertisement" />\n					</picture>\n				</a>\n				<a href="/account/settings" class="hidden-mobile">\n					<picture>\n						<source srcset="'+
((__t=( avatar_url ))==null?'':_.escape(__t))+
'" type="image/png">\n						<img src="/assets/images/test-avatar.png?v=1" alt="Default user avatar">\n					</picture>\n				</a>\n			</div>\n		';
 } 
__p+='\n\n	</div>\n</div>\n';
}
return __p;
};
